import styled from 'utils/emotion';
import { colors } from 'components/common/Layout/variables';

export const StyledFeedbackBox = styled('div')(
  {
    padding: 10,
    marginBottom: 20,
  },
  ({ type }) => ({
    backgroundColor:
      type === 'error'
        ? colors.error
        : type === 'success'
        ? colors.success
        : 'rgba(255, 255, 255, .2)',
  }),
);
